import React from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  TextField,
  Typography,
  Theme,
  FormControlLabel,
  Checkbox,
  Snackbar,
  Paper,
  createStyles,
} from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { Link } from 'react-router-dom';
import { useLoginForm } from './useLoginForm';

const Alert = (props: AlertProps) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    form: {
      paddingLeft: 30,
      paddingRight: 30,
      paddingTop: 36,
      paddingBottom: 32,
      [theme.breakpoints.down('sm')]: {
        paddingTop: 5,
        paddingBottom: 4,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
    title: {
      marginTop: theme.spacing(3),
      fontWeight: 'bolder',
    },
    textField: {
      marginTop: theme.spacing(4),
    },
    signInButton: {
      margin: theme.spacing(2, 0),
    },
  })
);

export const LoginForm = () => {
  const classes = useStyles();

  const {
    handleSubmit,
    open,
    handleClose,
    fields: { email, password, rememberMe },
    disabled,
  } = useLoginForm();

  return (
    <Paper>
      <form className={classes.form} onSubmit={handleSubmit}>
        <Snackbar
          open={open}
          autoHideDuration={1000}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          onClose={handleClose}
        >
          <Alert severity="error" onClose={handleClose}>
            Неверный логин или пароль!
          </Alert>
        </Snackbar>
        <Typography className={classes.title} variant="h4">
          Авторизация
        </Typography>
        <TextField
          className={classes.textField}
          error={!email.meta.valid && email.meta.touched}
          fullWidth
          helperText={!email.meta.valid && email.meta.touched ? email.meta.error : null}
          label="Email"
          type="text"
          variant="outlined"
          {...email.input}
        />
        <TextField
          className={classes.textField}
          error={!password.meta.valid && password.meta.touched}
          fullWidth
          helperText={!password.meta.valid && password.meta.touched ? password.meta.error : null}
          label="Пароль"
          type="password"
          variant="outlined"
          {...password.input}
        />
        <FormControlLabel
          control={<Checkbox color="primary" defaultChecked {...rememberMe.input} />}
          label="Запомнить меня"
        />
        <Link to="forgot-password">Забыли пароль?</Link>
        <Button
          className={classes.signInButton}
          color="primary"
          disabled={disabled}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
        >
          Войти
        </Button>
      </form>
    </Paper>
  );
};
